/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* The buying bidder and seat who can target this deal. [buyer_seats](https://docs.xandr.com/bundle/xandr-api/page/deal-service.html#DealService-BuyerSeats).
*/
export class V3BuyerSeat {
    /**
    * The bidder ID of the member.
    */
    'bidderId'?: number;
    /**
    * The identifier for the buyer seat.
    */
    'code'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "bidderId",
            "baseName": "bidder_id",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3BuyerSeat.attributeTypeMap;
    }

    public constructor() {
    }
}

